import type { VenueConfig } from "../config/types";
import { BOOKING_CHANNEL, type PublicBookingChannel, type WidgetChannel } from "../channel";

/**
 * The context the shell hands the booking journey — everything tasks/diner-booking-ui.md needs to
 * start rendering into a container that already solved embedding, isolation, resize, i18n, channel
 * plumbing, CSP, CORS and fail-safe states. The `bookingChannel` is the canonical `BookingChannel`
 * name (DOMAIN.md §B.6) the write path persists (spec R3).
 *
 * Lives in its own module so the mount seam (`pages/BookingFlowOutlet`) and the journey
 * (`booking/BookingJourney`) can both depend on the type without a dependency cycle.
 */
export interface BookingFlowContext {
  venueSlug: string;
  venueConfig: VenueConfig;
  channel: WidgetChannel;
  bookingChannel: PublicBookingChannel;
  /** Preview/test mode (the manager's live preview): the final submit is simulated, never a real write. */
  preview: boolean;
}

export function toBookingFlowContext(
  venueSlug: string,
  venueConfig: VenueConfig,
  channel: WidgetChannel,
  preview = false,
): BookingFlowContext {
  return { venueSlug, venueConfig, channel, bookingChannel: BOOKING_CHANNEL[channel], preview };
}
